import { Box, Typography } from '@mui/material';

interface CustomTabPanelProps
    extends React.HTMLAttributes<HTMLDivElement> {
    value: number;
    index: number;
    children?: React.ReactNode;
}

export const CustomTabPanel = ({ children, value, index }: CustomTabPanelProps) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && (
                <Box sx={{ pt: "16px" }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
